import lodash from 'lodash'

// EID 固定 32 位（字母数字，与 ICCID 录入字符集一致）
const eidPattern = /^[A-Za-z0-9]{32}$/
// 可处理的最大 EID 行数（与卡号一致）
export const maxEidLines = 100000

/**
 * 分析录入的 EID（支持波浪号连号，如 89049032005008820000000000000100~150）
 * @returns {{ lines: number, validEids: string[], errorText: string }}
 */
export function analyzeEids(inputText) {
  const rows = lodash.split(inputText || '', /\r*\n/)
  var totalLines = rows.length

  if (totalLines > maxEidLines) {
    return { lines: totalLines, validEids: [], errorText: '' }
  }

  var validEids = []
  var errorText = ''

  lodash(rows).forEach(function(value) {
    value = lodash.trim(value)
    if (!value) {
      return
    }

    if (value.indexOf('~') > 0) {
      const { lines, rangeEids } = parseRangeEids(value)
      totalLines = totalLines - 1 + lines
      if (totalLines > maxEidLines) {
        return
      }

      lodash(rangeEids).forEach(function(rangeEid) {
        const { isValid, eid } = validateEid(rangeEid)
        if (isValid) {
          validEids.push(eid)
        } else {
          errorText += eid
        }
      })
      return
    }

    const { isValid, eid } = validateEid(value)
    if (isValid) {
      validEids.push(eid)
    } else {
      errorText += eid
    }
  })

  if (totalLines > maxEidLines) {
    return { lines: totalLines, validEids: [], errorText: '' }
  }

  return { lines: totalLines, validEids: validEids, errorText: errorText }
}

/**
 * 处理范围 EID：89049032005008820000000000000100~150
 * 后缀位数与波浪号右侧一致，左侧补零，保证展开后仍为 32 位
 */
function parseRangeEids(inputText) {
  if (!/^[A-Za-z0-9]+[~][0-9]+$/.test(inputText)) {
    return { lines: 1, rangeEids: [inputText] }
  }

  const [fromEid, toVal] = inputText.split('~')
  if (fromEid.length !== 32) {
    return { lines: 1, rangeEids: [inputText] }
  }

  const suffixLen = toVal.length
  if (suffixLen > fromEid.length) {
    return { lines: 1, rangeEids: [inputText] }
  }

  var fromNumber = parseInt(fromEid.slice(-suffixLen), 10)
  if (isNaN(fromNumber)) {
    return { lines: 1, rangeEids: [inputText] }
  }
  const toNumber = parseInt(toVal, 10)
  if (isNaN(toNumber) || fromNumber >= toNumber) {
    return { lines: 1, rangeEids: [inputText] }
  }

  const count = toNumber - fromNumber + 1
  if (count > maxEidLines) {
    return { lines: count, rangeEids: [inputText] }
  }

  const prefix = fromEid.slice(0, -suffixLen)
  var eids = []
  for (var n = fromNumber; n <= toNumber; n++) {
    eids.push(prefix + String(n).padStart(suffixLen, '0'))
  }

  return { lines: eids.length, rangeEids: eids }
}

function validateEid(inputEid) {
  if (eidPattern.test(inputEid)) {
    return { isValid: true, eid: inputEid }
  }

  if (inputEid.indexOf(':') > 0) {
    return { isValid: false, eid: `${inputEid}\n` }
  }
  return { isValid: false, eid: `${inputEid}:EID须为32位字母或数字\n` }
}
